import { ScrollArea } from "@/components/ui/scroll-area"
import { cn } from "@/lib/utils"
import { Contact } from "./types"

interface ContactListProps {
  contacts: Contact[]
  selectedId: string | null
  onSelect: (id: string) => void
}

export function ContactList({ contacts, selectedId, onSelect }: ContactListProps) {

  return <div className="flex flex-col h-full border-r border-border bg-background">

    {/* Header */}
    <div className="px-4 py-3 border-border shrink-0">
      <span className="text-foreground font-semibold text-base">Events</span>
    </div>

    {/* Contact list */}
    <ScrollArea className="flex-1 [&_[data-slot=scroll-area-viewport]>:first-child]:block!">
      {contacts.length === 0 ? (<div className="flex items-center justify-center h-24 text-muted-foreground text-sm">No events found</div>) : (
        <div className="">
          {contacts.map(contact => {
            return <button
              key={contact.id}
              onClick={() => onSelect(contact.id)}
              className={cn("w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors text-left border-b border-border/50", selectedId === contact.id && "bg-muted")}
            >
              {/* Avatar */}
              <div className="relative shrink-0">
                <div className={cn("h-10 w-10 rounded-full flex items-center justify-center text-white font-semibold text-sm")}>
                  <div className="text-2xl">{contact.type}</div>
                </div>
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <span className="text-foreground text-sm font-medium truncate">{contact.name}</span>
                  <span className={cn("text-xs shrink-0 ml-2", contact.unreadCount > 0 ? "text-emerald-600 font-medium" : "text-muted-foreground")}>
                    {contact.lastMessageTime}
                  </span>
                </div>
                <div className="flex items-center justify-between mt-0.5">
                  <span className="text-muted-foreground text-xs truncate">{contact.lastMessage}</span>
                  {contact.unreadCount > 0 && <span className="ml-2 shrink-0 h-5 min-w-5 rounded-full bg-emerald-600 text-white text-[10px] font-semibold flex items-center justify-center px-1">
                    {contact.unreadCount}
                  </span>}
                </div>
              </div>
            </button>
          })}
        </div>
      )}
    </ScrollArea>
  </div>

}
